import type { AdminCustomerResponse } from "mws-finance-ts-sdk";

export const isAdminCustomerDto = (
  customer: unknown,
): customer is AdminCustomerResponse => {
  return (
    (customer as AdminCustomerResponse).id !== undefined &&
    (customer as AdminCustomerResponse).userId !== undefined &&
    (customer as AdminCustomerResponse).emailAddress !== undefined &&
    (customer as AdminCustomerResponse).addressReminderSent !== undefined
  );
};
